import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Typography } from "@mui/material";
import HeightBox from "../HeightBox";
import fontStyles from "./_fontStyles";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  textTransform: "uppercase",
  ...fontStyles,
}));

export const PoliceReportPrintOut = React.forwardRef((props, ref) => {
  const { formValues } = props;
  const name = formValues.fullName;
  const passportNumber = formValues.passport;
  const address = formValues.address;
  const idNumber = formValues.nationalId;
  return (
    <Container elevation={0} ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      <img
        src="/images/police_report_request.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      />
      <HeightBox height={538} />
      <CustomTypography style={{ marginLeft: 270 }}>{name}</CustomTypography>
      <HeightBox height={26} />
      <CustomTypography style={{ marginLeft: 270 }}>{passportNumber}</CustomTypography>
      <HeightBox height={14} />
      <CustomTypography style={{ marginLeft: 270 }}>{address}</CustomTypography>
      <HeightBox height={20} />
      <CustomTypography style={{ marginLeft: 270 }}>{idNumber}</CustomTypography>
    </Container>
  );
});
